import { createContext } from 'react';

const useTargetContext = createContext();
export default useTargetContext;
